import React from "react"

import logo from "../../../assets/images/logoCampana.png"
import elPoder from "../../../assets/images/elPoder.png"

import "./polygon-template.scss"

export default function PolygonTemplate(props) {
  const { children } = props
  return (
    <div className="polygon-template">
      <div className="polygon-template-container">
        <div className="polygon-template-container__logo">
          <img src={logo} />
          <div className="title">
            <p className="family-Bw-Black size-25 color-blue">
              La Zona V de la mujer es muy poderosa
            </p>
            <p className="family-H-Medium size-20 color-blue">
              Déjanos acompañarte a encontrar <br />
              un mundo de confianza, aprender <br />
              sobre tu cuerpo para eliminar <br />
              tabúes y descubrir
            </p>
          </div>
          <img className="imgElPoder" src={elPoder} alt="Logo de actividad" />
          <h2 className="family-Bw-Black size-25 color-blue">¿Tu misión?</h2>
          <h3 className="family-H-Medium size-20 color-blue">
            ¡Poner a prueba <br /> tu memoria!
          </h3>
        </div>
        <div className="polygon-template-container__body">{children}</div>
      </div>
    </div>
  )
}
